
import { combineReducers } from 'redux';

import variables from './variables';
import dataHoraObservacio from './dataHoraObservacio';
import peticioInserirEnCurs from './peticioInserirEnCurs';
import peticioObtenirFormulariEnCurs from './peticioObtenirFormulariEnCurs';

export default combineReducers({
    variables,
    dataHoraObservacio,
    peticioInserirEnCurs,
    peticioObtenirFormulariEnCurs
});



// WEBPACK FOOTER //
// ./src/reducers/observacio/formulari/index.js